import { ConfigProps } from '@config/types'

const config = ({ searchUrl }: ConfigProps) => ({
  apiUrl: `${searchUrl}/search`,
  sectionUrl: '/suche/',
  sectionUrl___romandie: '/fr/chercher/',
  moreInfoUrl:
    '/services/jetzt-anmelden-weshalb-sie-sich-auf-blick-ch-registrieren-sollten-id15546694.html',
  moreInfoUrl___romandie:
    '/fr/services/protection-des-donnees-l-essentiel-en-bref-sur-la-protection-des-donnees-id16472333.html',
  textHighlightClass: '@blick/search__highlighted-text',
  textHighlightColor: 'rgba(255,204,0,0.5)',
})

export type configType = ReturnType<typeof config>
export default config
